<template>
  <div>       
    <hr>
        <CarForSaleAdd  v-bind:dropDownDetails="dropDownDetails" updateItem=true></CarForSaleAdd> 
    <hr>                    
  </div>
</template>

<script>
import { eventBus } from '../main';
import { CarsDropDownMixin } from './mixin/CarsDropDownMixin';
export default {  
  mixins : [CarsDropDownMixin],
  data: function () {     
    return {
        
    }
  },
  created: function () {            
    this.getCarBrandDetails();
    this.getCarModelDetails();
    this.getCurrency();    
    this.getCarColors();
    this.getFuelType();
    this.getTransmissionsType();
    this.getCarType();
    this.getTractionType();   
    
  },
  mounted: function () {        
    
  },
  methods: {
        

  },
  filters: {
     
  },
  computed: {
    
  },  
  watch: {        
    
  },
  
}
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// CarForSaleAddPre.vue?61aabe3a